import * as Lodash from 'lodash/fp'

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
export function shuffle(array: Array<any>) {
  const a = [...array]

  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

export function reverse<T>(array: Array<T>) {
  const copy = [...array]
  const reversed = Lodash.reverse(copy)

  return reversed
}

export function withoutElementAtIndex<T>(array: Array<T>, index: number) {
  if (index > array.length - 1) {
    return array
  }

  const copy = [...array]
  copy.splice(index, 1)

  return copy
}

export function arrayToObject<T, V>(
  arr: T[],
  cb: (val: T) => [string, V],
): { [key: string]: V } {
  return arr.reduce((obj, item) => {
    const [key, value] = cb(item)

    return { ...obj, [key]: value }
  }, {})
}

export function findIndexAndElement<T>(
  array: T[],
  predicate: (elem: T) => boolean,
): [undefined, -1] | [T, number] {
  for (let i = 0; i < array.length; i++) {
    const item = array[i]
    if (predicate(item)) {
      return [item, i]
    }
  }

  return [undefined, -1]
}
